import { ReactElement } from 'react'
import { LoadingButton } from '@mui/lab'
import { Box, Button } from '@mui/material'
import { StickyFooter } from '@ui2/structure'
import RunningDocumentTasks from '../RunningDocumentTasks'
import useRunningDocumentTasks from '../RunningDocumentTasks/useRunningDocumentTasks'

interface Props {
  documentCount: number
  onShowDocuments: () => void
  onGenerateDocument: () => void
  // A started "Dokument erzeugen" run is still in progress
  isGenerating: boolean
  disableGenerate: boolean
}

// Footer of the document structure view. Running generations are listed with their
// progress; whenever a started run has no task listed there (before its first task
// shows up, between the Word and PDF tasks, while the result loads), "Dokument
// erzeugen" shows a loading state instead, so the run never looks finished early.
const DocumentGenerationFooter = ({
  documentCount,
  onShowDocuments,
  onGenerateDocument,
  isGenerating,
  disableGenerate,
}: Props): ReactElement => {
  const runningTasks = useRunningDocumentTasks()

  return (
    <StickyFooter>
      <RunningDocumentTasks tasks={runningTasks} />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
        <Button variant="outlined" size="small" onClick={onShowDocuments}>
          Dokumente anzeigen ({documentCount})
        </Button>
        <LoadingButton
          variant="contained"
          size="small"
          onClick={onGenerateDocument}
          loading={isGenerating && !runningTasks.length}
          disabled={disableGenerate}
          data-cy="btn-generate-document"
        >
          Dokument erzeugen
        </LoadingButton>
      </Box>
    </StickyFooter>
  )
}

export default DocumentGenerationFooter
